import { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";

import { useQuery, useMutation } from "@apollo/client";

import { ME, UPDATE_TELEGRAM_ID } from "../graphql/me";
import { Button, Typography } from "@mui/material";

export default function AccountPage() {
	const { loading, error, data, refetch } = useQuery(ME);
	const [
		updateTelegramId,
		{
			loading: updateTelegramIdLoading,
			error: updateTelegramIdError,
			data: updateTelegramIdData,
		},
	] = useMutation(UPDATE_TELEGRAM_ID);
	const [telegramId, setTelegramId] = useState("");
	useEffect(() => {
		setTelegramId(() => data?.me.telegramId);
	}, [data]);

	const handleConnectTelegramIdClicked = async () => {
		updateTelegramId({
			variables: {
				telegramId,
			},
		}).then(() => refetch());
	};

	if (loading) {
		return <div>Loading...</div>;
	}
	if (error) {
		return <div>Error communicating with server.</div>;
	}

	return (
		<Box
			sx={{
				margin: 5,
			}}
		>
			<Box
				sx={{
					marginBottom: 2,
				}}
			>
				<Typography>Your nickname: {data?.me.email}</Typography>
			</Box>
			<Box>
				<Typography
					sx={{
						marginBottom: 2,
					}}
				>
					Telegram link:
					<Link
						href="https://t.me/ca_pumps_bot"
						underline="none"
						target="_blank"
					>
						@ca_pumps_bot
					</Link>
				</Typography>
				<Box
					sx={{
						display: "flex",
						gap: 1,
						flexDirection: "row",
						alignItems: "center",
					}}
				>
					<TextField
						id="outlined-basic"
						label="Telegram Id"
						type="number"
						variant="outlined"
						sx={{ width: 200 }}
						value={telegramId}
						onChange={(event) => setTelegramId(event.target.value)}
					/>
					<Typography>
						(Use <b>/me</b> in bot for help)
					</Typography>
				</Box>
				<Box>
					{(!data?.me.telegramId || telegramId !== data?.me.telegramId) && (
						<Button
							onClick={handleConnectTelegramIdClicked}
							disabled={!telegramId || telegramId === data?.me.telegramId}
						>
							Connect
						</Button>
					)}
				</Box>
			</Box>
		</Box>
	);
}
